

export class MasterTemplateData {
    LSName: string;
    LSAccountBal: string;
    materiality: string;
    note: string;
    conclusion: string;
    tableData: WorkbookTableData[]
  }

  export class WorkbookTableData {
    nature: string;
    type: string;
    description: string;
    comments: string;
    wpRef: string;
    status: string;
    typeId: number;
    isHide: boolean;
    sortOrder: number;
    auther: string;
    created: string;
  }

  export const LSNature = [
    {
      key: "Required",
      value: "Required",
    },
    {
      key: "Additional Procedures",
      value: "Additional Procedures",
    },
    {
      key: "Optional",
      value: "Optional",
    }
  ];

  export const LSType = [
    {
      key: "Enquires",
      value: "Enquires",
    },
    {
      key: "Inquiries",
      value: "Inquiries",
    },
    {
      key: "Analytics",
      value: "Analytics",
    }
  ];

  export const LSNames = [
    {
      key : "A Cash",
      value : "A Cash"
    },
    {
      key : "B Accounts Receivable",
      value : "B Accounts Receivable"
    },
    {
      key : "C Inventory",
      value : "C Inventory"
    },
    {
      key : "D Investments",
      value : "D Investments"
    },
    {
      key : "E Loans and Advances Receivable",
      value : "E Loans and Advances Receivable"
    },
    {
      key : "F Related party",
      value : "F Related party"
    },
    {
      key : "H Property, Plant and Equipment",
      value : "H Property, Plant and Equipment"
    },
    {
      key : "I Prepaid expenses ",
      value : "I Prepaid expenses "
    },
    {
      key : "J Intangibles and Goodwill",
      value : "J Intangibles and Goodwill"
    },
    {
      key : "K Other Investments",
      value : "K Other Investments"
    },
    {
      key : "AA Bank indebtedness",
      value : "AA Bank indebtedness"
    },
    {
      key : "BB Accounts Payable and Accrued Liability",
      value : "BB Accounts Payable and Accrued Liability"
    },
    {
      key : "CC Income Taxes",
      value : "CC Income Taxes"
    },
    {
      key : "DD Note Payable and Bank Debt",
      value : "DD Note Payable and Bank Debt"
    },
    {
      key : "JJ Loans & Advances Payable",
      value : "JJ Loans & Advances Payable"
    },
    {
      key : "KK or NN Long Term Debt",
      value : "KK or NN Long Term Debt"
    },
    {
      key : "TT Equity",
      value : "TT Equity"
    },
    {
      key : "20 or 50 Revenue",
      value : "20 or 50 Revenue"
    },
    {
      key : "30 Cost of Sales",
      value : "30 Cost of Sales"
    },
    {
      key : "40 or 55 Payroll",
      value : "40 or 55 Payroll"
    },
    {
      key : "40 or 55 Other Expenses",
      value : "40 or 55 Other Expenses"
    },
    {
      key : "TB.1 Going Concern",
      value : "TB.1 Going Concern"
    },
    {
      key : "TB.2 Specific circumstances",
      value : "TB.2 Specific circumstances"
    },
    {
      key : "TB.3 Accounting Estimates",
      value : "TB.3 Accounting Estimates"
    },
    {
      key : "TB.4 Financial Instruments",
      value : "TB.4 Financial Instruments"
    },
    {
      key : "TB.5 Employee Future Benefits",
      value : "TB.5 Employee Future Benefits"
    },
    {
      key : "TB.6 First Time Adoption - ASPE",
      value : "TB.6 First Time Adoption - ASPE"
    }
  ];
export class WorksheetDuplicateFileS3Model {
  readonly status: number = 0;
  readonly module: string = "Worksheet: Master Template";
  readonly folderName: string = null;
  sourceFolder: string;//same as destinationFolder -->Folder path in s3
  destinationFolder: string;//same as sourceFolder -->Folder path in s3
  signatureKey: string; //same as sourceFolder,destinationFolder --> Folder path in s3
  fileName: string; //same as destFileName --> Filename to saved in s3
  filenames: string[];// Saving Multiple files in S3
  destinationFileNames: string[]; // Saving Multiple files in S3
  destinationFileName: string;//same as fileName --> Filename to saved in s3
  firmId: number;
  appSyncId: number; //loginId
 // sub_template_type:string;  //new column added by Amar.
}

export class WorksheetDuplicateTemplateModel {
  readonly templatetype: string = 'Worksheet';
  mastertemplateid: number | null = null;
  JsonFileName: string;
  JsonFilePath: string;
  TemplateName: any;
  templatefolderid: number;
  loginid: number;
  sub_template_type:string;
}

export class SaveWorksheetFirmTemplate {
  readonly templatetype: string = 'Worksheet';
  readonly mastertemplateid: string = '';
  JsonFileName: string;
  JsonFilePath: string;
  TemplateName: string;
  templatefolderid: number;
  loginid: number;
}

export class deleteWorkSheetModel {
  FirmTemplateID: number;
  templatefolderid?: number;
  loginid: number;
  templateType:string;
}

export class LSNameModel {
  templatename: string;
  master_template_uid: string;
  templatefolderid?: number;
}
